module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-down-grey-84e708c69e44f5667d7621999e890020.svg";